import React from 'react';
import ReactDOM from 'react-dom';

import App from '@/App';
import { BrowserRouter } from "react-router-dom";
import zhCN from 'antd/es/locale/zh_CN';
import ErrorBoundary from './components/ErrorBoundary';
import Modal from 'react-modal';
import { ConfigProvider } from 'antd';
import 'antd-mobile/es/global';
import '@/i18n';

// CSS 变量必须最先加载
import '@/assets/css/tokens.css';
import '@/assets/css/index.less';

// 检测移动端设备
const IsMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

const shouldEnableVConsole = (
  (ENV !== 'prod' && location.hostname !== 'localhost')
  || location.search.indexOf('debug=') >= 0
) && IsMobile;

if (shouldEnableVConsole) {
  import('vconsole').then(({ default: VConsole }) => {
    new VConsole();
  });
}

try {
  
  const rootElement = document.getElementById('root');

  Modal.setAppElement(rootElement);

  const renderApp = () => {
    ReactDOM.render(
      <React.StrictMode>
        <ErrorBoundary>
          <ConfigProvider locale={zhCN}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ConfigProvider>
        </ErrorBoundary>
      </React.StrictMode>,
      document.getElementById('root'),
    );
  };
  renderApp();
} catch (e) {
  console.log('e');
}
